import { Box, Grid, SimpleGrid } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { InputLabel, Select, TextInput, YesNoRadioButton } from "components";
import { TFunction } from "i18next";

interface CardAddressProps {
  form: UseFormReturnType<any, any>;
  t: TFunction;
}

const CardAddress = ({ form, t }: CardAddressProps) => {

  return (
    <Box p={'lg'}>
      <SimpleGrid cols={4}>
        <Select
          label={t('user.address.country.label')}
          placeholder={t('select.something')}
          key={form.key('country')}
          {...form.getInputProps('country')}
          data={form.getInputProps('country').defaultValue && [{
            value: form.getInputProps('country').defaultValue,
            label: t(`user.address.country.options.${form.getInputProps('country').defaultValue}`),
          }]}
          disabled={true}
        />
        <Grid>
          <Grid.Col span={4}>
            <TextInput
              label={t('user.address.postal.label')}
              key={form.key('postal')}
              {...form.getInputProps('postal')}
              disabled={true}
              maxLength={4}
            />
          </Grid.Col>
          <Grid.Col span={8}>
            <TextInput
              label={t('user.address.city.label')}
              key={form.key('city')}
              {...form.getInputProps('city')}
              disabled={true}
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={8}>
            <TextInput
              label={t('user.address.street.label')}
              key={form.key('street')}
              {...form.getInputProps('street')}
              disabled={true}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              label={t('user.address.houseNumber.label')}
              key={form.key('houseNumber')}
              {...form.getInputProps('houseNumber')}
              disabled={true}
            />
          </Grid.Col>
        </Grid>
        <Box>
          <InputLabel label={t('user.livingFrom.label')} />
          <Grid>
            <Grid.Col span={4}>
              <TextInput
                key={form.key('livingFrom')}
                {...form.getInputProps('livingFrom')}
                value={form.getInputProps('livingFrom').value && new Date(form.getInputProps('livingFrom').value).getFullYear()}
                disabled={true}
              />
            </Grid.Col>
            <Grid.Col span={8}>
              <TextInput
                key={form.key('livingFrom')}
                {...form.getInputProps('livingFrom')}
                value={form.getInputProps('livingFrom').value && t('month.' + new Date(form.getInputProps('livingFrom').value).getMonth())}
                disabled={true}
              />
            </Grid.Col>
          </Grid>
        </Box>
      </SimpleGrid>
      <SimpleGrid cols={4} mt={'md'}>
        <Select
          label={t('user.houseSituation.label')}
          placeholder={t('select.something')}
          key={form.key('houseSituation')}
          {...form.getInputProps('houseSituation')}
          data={form.getInputProps('houseSituation').defaultValue && [{
            value: form.getInputProps('houseSituation').defaultValue,
            label: t(`user.houseSituation.options.${form.getInputProps('houseSituation').defaultValue}`),
          }]}
          disabled={true}
        />
        <Select
          label={t('user.maritalStatus.label')}
          placeholder={t('select.something')}
          key={form.key('maritalStatus')}
          {...form.getInputProps('maritalStatus')}
          data={form.getInputProps('maritalStatus').defaultValue && [{
            value: form.getInputProps('maritalStatus').defaultValue,
            label: t(`user.maritalStatus.options.${form.getInputProps('maritalStatus').defaultValue}`),
          }]}
          disabled={true}
        />
        <YesNoRadioButton
          label={t('user.hasChildren.label')}
          name={'hasChildren'}
          form={form}
          disabled={true}
        />
        <TextInput
          label={t('user.childrenBirthYear.label')}
          key={form.key('childrenBirthYear')}
          {...form.getInputProps('childrenBirthYear')}
          value={form.getInputProps('childrenBirthYear').value}
          disabled={true}
        />
      </SimpleGrid>
    </Box>
  )
}

export default CardAddress;